import Debug, { snap } from "@/react/debug";
import schema from "./schema";

const QUEUE_ID_COLUMN_KEY = schema.fields.queueId.spec.key;
const AGENT_ID_COLUMN_KEY = schema.fields.agentId.spec.key;
const AGENT_NAME_COLUMN_KEY = schema.fields.agentName.spec.key;
const QUEUE_NAME_COLUMN_KEY = schema.fields.queueName.spec.key;
const QUEUE_MEDIA_TYPE_COLUMN_KEY = schema.fields.mediaType.spec.key;

const syncAgentIdAndName = (row, getAgentById, getAgentByUsername) => {
  let agentId = row[AGENT_ID_COLUMN_KEY];
  let agentName = row[AGENT_NAME_COLUMN_KEY];
  if (agentId && !agentName) {
    agentName = getAgentById(agentId)?.sso.sso_username;
    Debug.log(`Auto-applied agent ID '${agentId}'`);
  } else if (!agentId && agentName) {
    agentId = getAgentByUsername(agentName)?.sso.sso_id;
    Debug.log(`Auto-applied agent name '${agentName}'`);
  }
  return { agentId, agentName };
};

const syncQueueIdAndName = (row, getQueueById, getQueueByName) => {
  let queueId = row[QUEUE_ID_COLUMN_KEY];
  let queueName = row[QUEUE_NAME_COLUMN_KEY];
  if (queueId && !queueName) {
    queueName = getQueueById(queueId)?.name;
  } else if (!queueId && queueName) {
    queueId = getQueueByName(queueName)?.id;
  }
  return { queueId, queueName };
};

const syncMediaTypeWithQueue = (row, queueId, getQueueById) => {
  let mediaType = row[QUEUE_MEDIA_TYPE_COLUMN_KEY];
  if (queueId) {
    const queue = getQueueById(queueId);
    if (queue && !mediaType) {
      mediaType = queue.media_type;
    }
  }
  return mediaType;
};

export const useAssignmentsAutofill = (queryFunctions) => {
  const { getAgentById, getAgentByUsername, getQueueById, getQueueByName } =
    queryFunctions;
  return (rowsData, schema) => {
    let seenSet = new Set();
    return rowsData?.map((row) => {
      Debug.log("Original row", snap(row));

      // 1. Sync agent ids and names if only one exists
      let { agentId, agentName } = syncAgentIdAndName(
        row,
        getAgentById,
        getAgentByUsername
      );

      // 2. Sync queue ids and names if only one exists
      let { queueId, queueName } = syncQueueIdAndName(
        row,
        getQueueById,
        getQueueByName
      );

      // 3. Sync the media type with the given queue, if the queue is valid
      const mediaType = syncMediaTypeWithQueue(row, queueId, getQueueById);

      // 4. Update the row with the (potentially) new values
      row[AGENT_ID_COLUMN_KEY] = agentId;
      row[AGENT_NAME_COLUMN_KEY] = agentName;
      row[QUEUE_ID_COLUMN_KEY] = queueId;
      row[QUEUE_NAME_COLUMN_KEY] = queueName;
      row[QUEUE_MEDIA_TYPE_COLUMN_KEY] = mediaType;

      Debug.log("Updated row", snap(row));
      return row;
    });
  };
};
